import { Component, inject, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom, Subscription } from 'rxjs';
import { CustomButtonComponent } from 'src/app/components/custom-components/custom-button/custom-button.component';
import { ElectronicDocumentService } from 'src/app/services/invoicing/electronic-document.service';

@Component({
  selector: 'app-electronic-document-info',
  templateUrl: './electronic-document-info.component.html',
  styleUrls: ['./electronic-document-info.component.scss'],
  standalone: true,
  imports: [CustomButtonComponent]
})
export class ElectronicDocumentInfoComponent implements OnInit {

  private readonly config = inject(DynamicDialogConfig);
  private readonly electronicDocumentService = inject(ElectronicDocumentService);
  private readonly ref = inject(DynamicDialogRef);

  documentId: number | null = null;
  responseElectronicDocument: any | null = null;
  subscription: Subscription;
  typeDocument: number | null = null;

  ngOnInit() {
    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }

    this.subscription = input$?.subscribe((inputs: any) => {
      this.typeDocument = inputs.typeDocument;
      this.documentId = inputs.documentId;
    });

    this.checkElectronicDocument(this.typeDocument || 0, this.documentId || 0);
  }

  close() {
    this.ref.close();
  }

  async checkElectronicDocument(typeDocument: number, documentId: number) {
    try {
      this.responseElectronicDocument = await firstValueFrom(
        this.electronicDocumentService.checkElectronicDocument(typeDocument, documentId)
      );
    } catch (error) {
      this.close();
      console.error('Error al consultar el documento electrónico:', error);
    }
  }

}
